export default {
  name: 'contract',
  translationKey: 'contracts-module',
  routePrefix: 'contract',
  routeNamePrefix: 'contract',
  directRoutesAvailable: true,
}
